/* HOMEHEART — lokaliserar den app-injicerade country selectorns panelrubriker. */
(function () {
  'use strict';

  var TEXT = {
    sv: { region: 'Land/region', language: 'Språk', dialog: 'Land/region och språk', open: 'Välj land/region och språk', close: 'Stäng' },
    no: { region: 'Land/region', language: 'Språk', dialog: 'Land/region og språk', open: 'Velg land/region og språk', close: 'Lukk' },
    nl: { region: 'Land/regio', language: 'Taal', dialog: 'Land/regio en taal', open: 'Kies land/regio en taal', close: 'Sluiten' },
    cs: { region: 'Země/oblast', language: 'Jazyk', dialog: 'Země/oblast a jazyk', open: 'Vyberte zemi/oblast a jazyk', close: 'Zavřít' },
    de: { region: 'Land/Region', language: 'Sprache', dialog: 'Land/Region und Sprache', open: 'Land/Region und Sprache wählen', close: 'Schliessen' },
    fr: { region: 'Pays/région', language: 'Langue', dialog: 'Pays/région et langue', open: 'Choisir le pays/la région et la langue', close: 'Fermer' },
    it: { region: 'Paese/regione', language: 'Lingua', dialog: 'Paese/regione e lingua', open: 'Scegli paese/regione e lingua', close: 'Chiudi' }
  };

  function normalizeCurrencyLabels(selector) {
    selector.querySelectorAll('.tl-selection.tl-currency > .tl-label, .tl-options .tl-label').forEach(function (label) {
      var value = label.textContent.replace(/\s+/g, ' ').trim();
      var duplicated = value.match(/^(.*\()([A-Z]{3})\s+\2(\))$/);
      if (duplicated) label.textContent = duplicated[1] + duplicated[2] + duplicated[3];
    });
  }

  function localizeSelector(root) {
    var lang = (document.documentElement.lang || 'sv').split('-')[0].split('_')[0];
    var text = TEXT[lang];
    if (!text) return;
    var scope = root && root.querySelectorAll ? root : document;
    var selectors = [];
    if (scope.matches && scope.matches('.tl-switcher-container')) selectors.push(scope);
    scope.querySelectorAll('.tl-switcher-container').forEach(function (node) { selectors.push(node); });

    selectors.forEach(function (selector) {
      var titles = selector.querySelectorAll('.tl-dropdown .tl-inner > .tl-title');
      if (titles[0] && titles[0].textContent !== text.region) titles[0].textContent = text.region;
      if (titles[1] && titles[1].textContent !== text.language) titles[1].textContent = text.language;
      var trigger = selector.querySelector('.tl-selections');
      if (trigger) trigger.setAttribute('aria-label', text.open);
      var dialog = selector.querySelector('.tl-dropdown[role="dialog"]');
      if (dialog) dialog.setAttribute('aria-label', text.dialog);
      var selects = selector.querySelectorAll('.tl-dropdown .tl-select');
      if (selects[0]) selects[0].setAttribute('aria-label', text.region);
      if (selects[1]) selects[1].setAttribute('aria-label', text.language);
      var listboxes = selector.querySelectorAll('.tl-options[role="listbox"]');
      listboxes.forEach(function (listbox, index) {
        listbox.setAttribute('aria-label', index === 0 ? text.region : text.language);
      });
      selector.querySelectorAll('.tl-flag').forEach(function (flag) {
        flag.setAttribute('alt', '');
        flag.setAttribute('aria-hidden', 'true');
      });
      var close = selector.querySelector('.tl-close-btn');
      if (close) {
        close.setAttribute('aria-label', text.close);
        close.setAttribute('title', text.close);
      }
      normalizeCurrencyLabels(selector);
    });
  }

  function start() {
    localizeSelector(document);
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        change.addedNodes.forEach(function (node) {
          var element = node.nodeType === 1 ? node : node.parentElement;
          if (!element) return;
          var selector = element.closest && element.closest('.tl-switcher-container');
          localizeSelector(selector || document);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
